export default __webpack_public_path__ + "static/media/rain.0b9a64b6.svg";